import React from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../context';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';


function ContactUs() {
  const {t} = useTranslation()
  const { openContact, initial, final, animation1,  buttonEnter, Leave } = useGlobalContext();
  return (
    <section className="section contact_us">
        <div className="container contact_us__container">
            <motion.h2 
            initial={initial}
            whileInView={final}
            transition={animation1}
            viewport={{once: true}}
            className="contact_us__title">{t('footer')}</motion.h2>
            <Link className="cta">
                <motion.button 
                initial={initial}
                whileInView={final}
                transition={animation1}
                viewport={{once: true}}
                onMouseEnter={buttonEnter}
                onMouseLeave={Leave}
                onClick={() => openContact()}
                className="cta__button">Contact</motion.button>
            </Link>
        </div>
    </section>
  )
}

export default ContactUs;